//
// @Nick
// This is not supposed to be any. help me. Im realy bad at typescripting
//

export function RadioInput({ label, id, name, index, value, refs, handler }: any) {

    return (
        <span className="radio" onClick={() => refs.current[index]?.click()}>
            <input type="radio" id={id} name={name} value={value} onChange={handler} ref={el => refs.current[index] = el} ></input>
            <label htmlFor={id}>{label}</label>
        </span>
    )
}